import React from 'react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

const CustomRange = (props) => (
  <div>
    <DateRange dateFormat="yyyy/MM/dd" ranges={[props.selectionRange]} onChange={props.handleSelect} />
  </div>
);

export default CustomRange;
